var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home-page"},[_c('div',[_vm._v(" 欢迎登录物流服务平台！ ")])])
}]

export { render, staticRenderFns }